'use strict';

var RomSummaryDOWChartFilterFactory = function RomSummaryDOWChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory', 'ROMSummaryRomTimeBucketFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryDOWChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'day-of-week-thematic-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryDOWChartFilter.constructor = RomSummaryDOWChartFilter;
  RomSummaryDOWChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryDOWChartFilter;
};
RomSummaryDOWChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryDOWChartFilterFactory;